type SurveyCompletionMap = Record<string, { completedAt: number }>;

function getStorageKey(classroomId: string): string {
  return `takween-survey-completions:${classroomId}`;
}

function canUseLocalStorage(): boolean {
  return typeof window !== 'undefined' && typeof window.localStorage !== 'undefined';
}

export function getTakweenSurveyCompletions(classroomId?: string): SurveyCompletionMap {
  if (!classroomId || !canUseLocalStorage()) {
    return {};
  }

  const raw = window.localStorage.getItem(getStorageKey(classroomId));
  if (!raw) {
    return {};
  }

  try {
    const parsed = JSON.parse(raw) as SurveyCompletionMap;
    return parsed || {};
  } catch (error) {
    console.error('Failed to parse Takween survey completion data:', error);
    return {};
  }
}

export function markTakweenSurveyComplete(classroomId: string, studentId: string): void {
  if (!canUseLocalStorage()) {
    return;
  }

  const completions = getTakweenSurveyCompletions(classroomId);
  completions[studentId] = { completedAt: Date.now() };
  window.localStorage.setItem(getStorageKey(classroomId), JSON.stringify(completions));
}

export function hasTakweenSurveyCompleted(classroomId?: string, studentId?: string): boolean {
  if (!classroomId || !studentId) {
    return false;
  }

  const completions = getTakweenSurveyCompletions(classroomId);
  return !!completions[studentId];
}

export function getTakweenSurveyCompletionSummary(
  classroomId: string | undefined,
  total: number,
): {
  completed: number;
  total: number;
} {
  if (!classroomId) {
    return { completed: 0, total };
  }

  return {
    completed: Object.keys(getTakweenSurveyCompletions(classroomId)).length,
    total,
  };
}
